<template>
    <div class="policy-version-stack">
        <ChildPrivacyPolicy20250422Content />
        <PersonalInfoPolicy20250422Content />
    </div>
</template>

<script>
import ChildPrivacyPolicy20250422Content from '@/views/policy/common/ChildPrivacyPolicy20250422Content.vue';
import PersonalInfoPolicy20250422Content from '@/views/policy/common/PersonalInfoPolicy20250422Content.vue';

export default {
    name: 'ChildPolicy20250422',
    components: {
        ChildPrivacyPolicy20250422Content,
        PersonalInfoPolicy20250422Content,
    },
};
</script>
